import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import Header from "../components/Header";
import { useDispatch, useSelector } from "react-redux";
import { getBookmarks } from "../Redux/BookmarkReducer/action";
import { convertDate, convertTimeFormat } from "../Services";
import { Link } from "react-router-dom";
import { Loader } from "../components/Loader";

const Bookmark = () => {
  const user = useSelector((state) => state.AuthReducer.user);
  const token = useSelector((state) => state.AuthReducer.token);
  const bookmarks = useSelector((state) => state.BookmarkReducer.bookmarks);
  const loading = useSelector((state) => state.BookmarkReducer.isLoading);
  const dispatch = useDispatch();
  const userId = user.id;
  const name = user.name;
  const role = user.roles[0].name;

  useEffect(() => {
    if (bookmarks?.length === 0) {
      dispatch(getBookmarks(userId, token));
    }
  }, [dispatch, bookmarks.length]);
  console.log("bookmarks", bookmarks);

  return (
    <div className="bg-[#f3f4f6]">
      <Navbar name={name} role={role} />
      <Header title={"Bookmark"} role={role} />
      <main>
        <div className="py-12 ">
          {loading ? <Loader /> : ""}
          <div className="max-w-7xl mx-auto sm:px-6 lg:px-8 ">
            <h1 className="text-left px-16">Lectures</h1>
            <div className="flex flex-col ">
              <div className="-my-2 overflow-x-auto sm:mx-6 lg:mx-8 ">
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8 ">
                  <div className="shadow overflow-hidden border-b border-green-200 sm:rounded-lg ">
                    <table className="min-w-full divide-y divide-gray-200 ">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Title
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Author
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Schedule
                          </th>
                          <th className="relative px-6 py-3 ">
                            <span className="sr-only">View</span>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {bookmarks.length > 0 &&
                          bookmarks.map((item) => {
                            return (
                              <tr
                                key={item.lectureId}
                                className="bg-white divide-y divide-gray-200"
                              >
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900  text-left">
                                  <Link
                                    to={`/lectures/${item.lectureId}`}
                                    className="text-indigo-600 hover:text-indigo-900"
                                  >
                                    {item.title}
                                  </Link>
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-left">
                                  {item.createdBy}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-left">
                                  {`${convertDate(
                                    item.startTime
                                  )} ${convertTimeFormat(item.startTime)}`}
                                </td>
                                <td className="pr-6 py-4 whitespace-nowrap text-center text-sm font-medium ">
                                  <Link
                                    to={`/lectures/${item.lectureId}`}
                                    className="text-indigo-600 hover:text-indigo-900"
                                  >
                                    View
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Bookmark;
